import { Link } from 'react-router-dom';
import { brand } from '@/config/brand';

export function TermsPage() {
  return (
    <article className="panel prose-page">
      <h1>Terms of use</h1>
      <p>
        By using {brand.name} ({brand.domain}), you agree to these terms. If you
        do not agree, do not use the site.
      </p>

      <h2>Audience</h2>
      <p>{brand.adultNotice}</p>

      <h2>Informational service only</h2>
      <p>
        {brand.name} provides informational comparisons of alcohol content,
        calories, carbohydrates (when available), and package prices. It is not
        medical, nutritional, legal, or financial advice. Calculations may rely
        on estimated, incomplete, regional, or outdated data — always verify
        producer labels and the prices you actually pay.
      </p>
      <p>
        {brand.positioning} Standard-drink equivalence does not guarantee
        identical subjective effects. Do not use this site to plan excessive
        drinking, competitive drinking, or impaired driving.
      </p>

      <h2>No alcohol sales</h2>
      <p>
        We do not sell alcoholic beverages, process alcohol orders, or operate a
        liquor storefront. Links and numbers are for comparison and literacy, not
        for purchasing alcohol through {brand.name}.
      </p>

      <h2>Your responsibilities</h2>
      <ul>
        <li>Use the site only if you are of legal drinking age.</li>
        <li>Do not misuse share links to harass or mislead others.</li>
        <li>
          Do not attempt to disrupt the service, scrape in ways that harm
          availability, or inject malicious content via feedback.
        </li>
        <li>Drink responsibly and follow local laws.</li>
      </ul>

      <h2>User-entered prices</h2>
      <p>
        Price overrides you enter are stored on your device. If you include them
        in a share URL, you are responsible for what that link reveals. We do
        not guarantee accuracy of user-entered or reference prices.
      </p>

      <h2>Intellectual property</h2>
      <p>
        Site design, original guides, and explanatory copy are provided for
        personal, non-commercial use of the comparison tools unless we state
        otherwise. Product names and trademarks belong to their respective
        owners and are used for identification.
      </p>

      <h2>Disclaimer of warranties</h2>
      <p>
        The service is provided “as is” without warranties of any kind, express
        or implied, including accuracy, completeness, or fitness for a particular
        purpose.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, {brand.name} and its operators
        are not liable for damages arising from use of or inability to use the
        site, including decisions made based on rankings or estimates.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms as the product evolves. Continued use after
        changes constitutes acceptance of the updated terms. See also{' '}
        <Link to="/privacy/">Privacy</Link> and{' '}
        <Link to="/methodology/">Methodology</Link>.
      </p>

      <h2>Contact</h2>
      <p>
        Questions:{' '}
        {brand.contactEmail ? (
          <a href={`mailto:${brand.contactEmail}`}>{brand.contactEmail}</a>
        ) : (
          'configure owner email'
        )}{' '}
        · <Link to="/feedback/">Feedback</Link>
      </p>
      <p className="muted">Last updated: October 21, 2026.</p>
    </article>
  );
}
